import React, { useState, useEffect, useContext } from 'react';
import { ArrowLeft, Copy, X, Home, ShoppingBag, Users, BarChart4, Settings } from 'lucide-react';


import SuccesBottomSheet from './SuccesBottomSheet';

import AppContext from '../../context/AppContext';

import { useSearchParams, useNavigate } from 'react-router-dom';
import { UserKeysService } from '../../db/Aggregator/UserKeysService';

const ModifierKeyIndex = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [cle, setCle] = useState('');
  const cleActuelle = 'a4925965c62c957edaa8070716113b93a91';
  const navigate = useNavigate();

  const { isSplashVisible, isLoading,id,bottom, setBottom } = useContext(AppContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [searchParams] = useSearchParams();
  const nom = searchParams.get('nom');

  const key = searchParams.get('key');


  const idA = searchParams.get('id');

  

  const copyToClipboard =  () => {
    navigator.clipboard.writeText(cleActuelle);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Début du chargement
    
    try {
      console.log('Nouvelle clé:', cle);
      await UserKeysService.saveUserKeys(
        id,
        nom,
        {
          apiKey: cle,
          secretKey: "ma-clé-secrète"
        }
      );
      setBottom(<SuccesBottomSheet/>);
      navigate('/SuccesBottomSheetIndex');
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setIsSubmitting(false); // Fin du chargement
    }
  }



  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    // Naviguer vers la page principale des méthodes de paiement
    setTimeout(() => {
      navigate('/PaymentsSheetsIndex');
    }, 300);
  };

  // Fonction d'urgence pour retourner à l'accueil
  const backToHome = () => {
    navigate('/IndexEspace');
  };

  return (
    <div>
      {/* Bouton d'accueil d'urgence avec lien HTML simple */}
      <div className="fixed top-4 left-4 z-[9999]">
        <a 
          href="/IndexEspace"
          className="p-2 bg-blue-600 text-white rounded-full shadow-lg inline-flex"
          aria-label="Retour à l'accueil"
        >
          <Home size={20} />
        </a>
      </div>
      
      {/* Overlay avec effet de flou */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={handleClose}
        />
      )}

      {/* Bottom Sheet avec animation */}
      <div className={`
        fixed left-0 right-0 bottom-0 z-50 
        transform transition-transform duration-500 ease-out
        ${isOpen ? 'translate-y-0' : 'translate-y-full'}
      `}>
        <div className="bg-white rounded-t-3xl shadow-2xl  overflow-y-auto"
        
        
        style={{ 
            transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
            height: '99vh'
          }}>
          {/* Barre de poignée */}
          <div className="flex justify-center pt-4">
            <div className="w-12 h-1 bg-gray-200 rounded-full" />
          </div>

          <div className="p-6">
            {/* En-tête avec bouton de fermeture */}
            <div className="flex justify-between items-center mb-6">
              <button 
                onClick={handleClose}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
              >
                <ArrowLeft size={24} />
              </button>
              <h2 className="text-xl font-bold text-gray-900">
                Configuration {nom}
              </h2>
              <div className="w-8"></div> {/* Spacer pour centrer le titre */}
            </div>

            <p className="text-gray-600 text-center mb-8">
              Pour activer cet agrégateur de paiement, veuillez enregistrer votre clé publique ci-dessous
            </p>

            {/* Carte de la clé actuelle */}
           

            {/* Note de sécurité */}
            <div className="bg-blue-50 p-4 rounded-xl mb-6">
              <p className="text-sm text-blue-700 text-center">
                🔒 Vos données sont sécurisées et cryptées
              </p>
            </div>

            {/* Formulaire */}
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <label className="block text-gray-700 font-medium">
                  Nouvelle clé publique
                </label>
                <input
                  type="text"
                  required
                  placeholder="Entrez votre clé publique"
                  className="w-full px-4 py-3.5 rounded-xl border border-gray-200 bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  value={cle}
                  onChange={(e) => setCle(e.target.value)}
                />
              </div>

              <button
  type="submit"
  disabled={isSubmitting}
  className={`w-full bg-blue-600 text-white py-4 rounded-xl font-medium 
    ${isSubmitting ? 'opacity-75 cursor-not-allowed' : 'hover:bg-blue-700 transform hover:-translate-y-0.5'} 
    transition-all duration-200 shadow-md hover:shadow-lg`}
>
  {isSubmitting ? 'Enregistrement en cours...' : 'Enregistrer'}
</button>

             
            </form>
          </div>
        </div>
      </div>
      
      {/* Navigation avec simples liens HTML */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-[999999]" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
        <div className="max-w-lg mx-auto flex justify-between">
          <a 
            href="/IndexEspace"
            className="flex flex-col items-center p-2 flex-1 text-gray-500 hover:text-blue-600 active:bg-gray-100"
          >
            <Home className="w-6 h-6" />
            <span className="text-xs mt-1">Accueil</span>
          </a>
          
          <a 
            href="/ProductsList"
            className="flex flex-col items-center p-2 flex-1 text-gray-500 hover:text-blue-600 active:bg-gray-100"
          >
            <ShoppingBag className="w-6 h-6" />
            <span className="text-xs mt-1">Produits</span>
          </a>
          
          <a 
            href="/GroupeListe"
            className="flex flex-col items-center p-2 flex-1 text-gray-500 hover:text-blue-600 active:bg-gray-100"
          >
            <Users className="w-6 h-6" />
            <span className="text-xs mt-1">Groupes</span>
          </a>
          
          <a 
            href="/Statistics"
            className="flex flex-col items-center p-2 flex-1 text-gray-500 hover:text-blue-600 active:bg-gray-100"
          >
            <BarChart4 className="w-6 h-6" />
            <span className="text-xs mt-1">Stats</span>
          </a>
          
          <a 
            href="/PaymentsSheetsIndex"
            className="flex flex-col items-center p-2 flex-1 text-blue-600"
          >
            <Settings className="w-6 h-6" />
            <span className="text-xs mt-1">Réglages</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModifierKeyIndex;